"use client";

import React from "react";
import { ArrowRight, CircleCheck as CheckCircle2, Headphones, Mail } from 'lucide-react';
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const guarantees = [{
  text: "Dedicated application specialists across Ireland & the UK"
}, {
  text: "Full qualification & regulatory compliance support (IQ/OQ/PQ)"
}, {
  text: "Responsive lifecycle maintenance options"
}];
export default function Cta() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="closingcalltoaction" data-nav="light" className="bg-background py-16 md:py-24 border-t border-border">
      <div className="page-container">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="relative overflow-hidden rounded-2xl bg-secondary/60 border border-border px-6 py-12 md:px-12 md:py-16 shadow-sm">
          {/* Subtle decorative background glow */}
          <div aria-hidden="true" className="pointer-events-none absolute -right-20 -top-20 size-80 rounded-full bg-primary/10 blur-3xl" />
          <div aria-hidden="true" className="pointer-events-none absolute -left-20 -bottom-20 size-80 rounded-full bg-chart-2/10 blur-3xl" />

          <div className="relative z-10 max-w-3xl mx-auto text-center">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary/10 px-3.5 py-1 text-xs font-semibold uppercase tracking-wider text-primary">
              Ready to Upgrade Your Analytical Workflow?
            </span>

            <h2 className="mt-4 font-default text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl">
              Talk with our technical specialists about your laboratory needs.
            </h2>

            <p className="mt-4 text-base md:text-lg text-muted-foreground leading-relaxed">
              From application-led instrumentation selection to complete installation,
              qualification, and lifecycle maintenance across Ireland and the UK.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button asChild size="lg" className="w-full sm:w-auto font-medium shadow-md">
                <Link to="/ContactPage" className="inline-flex items-center gap-2">
                  <span>Speak with a Specialist</span>
                  <ArrowRight className="size-4" />
                </Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto bg-card hover:bg-muted font-medium">
                <Link to="/SolutionsPage" className="inline-flex items-center gap-2">
                  <span>Browse Solutions</span>
                </Link>
              </Button>
            </div>

            <div className="mt-10 pt-8 border-t border-border/80">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-left sm:text-center md:text-left">
                {guarantees.map((item, i) => <div key={item.text} data-index={i} className="flex items-start gap-2.5 justify-start md:justify-center">
                    <CheckCircle2 className="size-5 text-primary shrink-0 mt-0.5" />
                    <span className="text-sm font-medium text-foreground/90">
                      {item.text}
                    </span>
                  </div>)}
              </div>
            </div>

            <div className="mt-8 flex items-center justify-center gap-6 text-xs text-muted-foreground">
              <div className="flex items-center gap-1.5">
                <Headphones className="size-3.5 text-muted-foreground" />
                <span>Responsive local engineering support</span>
              </div>
              <div className="hidden sm:inline">•</div>
              <div className="flex items-center gap-1.5">
                <Mail className="size-3.5 text-muted-foreground" />
                <span>Fast response to technical inquiries</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}